<template>
  <div class="box box-info">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Language" :visible.sync="displayBasic"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="level">Name<span style="color:red">*</span></label>
            <InputText v-model.trim="name"  id="level"/>
          </div>
        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addLanguage" :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" @click.prevent="addAndNewExtraExpenses" v-if="!editing"
                      label="Add & New"/>
              <Button  class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="languageList" :paginator="true" :rows="8" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N" >
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="value"  filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['value']" />
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editLanguage(slotProps.data)" />
          <!--        <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"-->
          <!--                @click="editSalesOrder(slotProps.data)"/>-->
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <!--        <Button v-else disabled class="p-button-raised p-button-danger"-->
          <!--                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
          <!-- Delete Button -->
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteLicense"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
export default {
  name: 'language',
  data() {
    return {
      displayBasic: false,
      name: '',
      loading: false,
      editing: false,
      languageId: null,
      deleteDialog: false,
      filters: {}
    }
  },
  computed: {
    languageList() {
      return this.$store.state.hr.languageList
    }
  },
  mounted() {
    this.findLanguage()
  },
  methods: {
    async findLanguage() {
      await this.$store.dispatch('loadHrMasterSetupList', 'Language')
    },
    async addLanguage() {
      if (this.name === '') {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Name cannot be empty!', life: 3000})
        return
      }
      let license = {
        id: this.languageId,
        value: this.name,
        type: 'Language'
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createHrMasterSetup', license)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateHrMasterSetup', license)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editLanguage(data) {
      this.editing = true
      this.languageId = data.id
      this.name = data.value
      this.openBasic()
    },
    async deleteLicense(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let language = {
        id: this.languageId,
        deleteReason: value,
        type: 'Language'
      }
      try {
        let response = await this.$store.dispatch('deleteHrMasterSetup', language)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Language' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    reset() {
      this.name = ''
      this.displayBasic = false
    },
    openDeleteDialog(id) {
      this.languageId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// language.vue?5210b388